import { render } from "./PaymentTermImportPanel.vue?vue&type=template&id=89a72570"
import script from "./PaymentTermImportPanel.vue?vue&type=script&lang=js"
export * from "./PaymentTermImportPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__